// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import "@37signals/lexxy"

require("@popperjs/core")

//import * as bootstrap from 'bootstrap'
import "./src/check_ins"
import "./src/gridzy.min"

// disable automatic initializations
Gridzy.setDefaultOptions({
  autoInitOnDomReady: false,
  autoInitOnDomMutation: false
});

import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

import { initMDB, Tab, Sticky, Tooltip, Collapse, Modal } from 'mdb-ui-kit';
window.MDB = { Modal, Tab, Sticky, Tooltip, Collapse };


// Adapt Stimulus for Webpack
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
window.Stimulus = Application.start()
const context = require.context("./controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

window.piexif = require("piexifjs")

ActiveStorage.start()
//window.bootstrap = bootstrap;

import "colorthief"

import lightgallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

document.addEventListener("turbo:load", () => {
  console.log("turbo:load event fired");
  initMDB({Tab, Sticky, Tooltip, Collapse, Modal});
});

document.addEventListener("turbo:frame-load", () => {
  console.log("turbo:frame-load event fired");
  initMDB({Tab, Sticky, Tooltip, Collapse, Modal});
});
